import type { ComponentType, FC } from 'react';
import dynamic from 'next/dynamic';
const StaticPage = dynamic(() => import('@/templates/StaticPage'));
const ResultsPage = dynamic(() => import('@/templates/ResultsPage'));
const TravelTypePage = dynamic(() => import('@/templates/TravelTypePage'));
const ShipPage = dynamic(() => import('@/templates/ShipPage'));
const WebsiteSearchPage = dynamic(() => import('@/templates/WebsiteSearchPage'));
const FaqPage = dynamic(() => import('@/templates/FaqPage'));
const InterestListPage = dynamic(() => import('@/templates/InterestListPage'));

export interface MagnoliaPagesMappingConfig {
  componentMappings: { [key: string]: FC<any> | ComponentType<any> };
}

export const pagesConfig: MagnoliaPagesMappingConfig = {
  componentMappings: {
    'website:pages/static': StaticPage,
    'website:pages/travelType': TravelTypePage,
    'website:pages/ship': ShipPage,
    'website:pages/faq': FaqPage,
    'website:pages/results': ResultsPage,
    'website:pages/websiteSearch': WebsiteSearchPage,
    'website:pages/interestList': InterestListPage
  }
};
